export default "/images/fe639977bc029edc48cd34373b2f05c8.avif";